import React, { useState } from 'react';

export default function AICommentary({ commentary, filter }) {
  const [expanded, setExpanded] = useState({});

  if (!commentary || !commentary.length) return null;
  const filtered = filter ? commentary.filter(c => c.section === filter) : commentary;
  if (!filtered.length) return null;

  const toggleExpand = (section) => setExpanded(prev => ({ ...prev, [section]: !prev[section] }));

  return (
    <div className="inv-ai-section">
      <h2 className="inv-section-title">
        <span>🤖</span> AI Intelligence Report
        <span className="inv-badge inv-badge-ai">DeepSeek</span>
      </h2>
      {filtered.map((c, i) => (
        <div key={i} className={`inv-commentary-card ${expanded[c.section] ? 'expanded' : ''}`}>
          <div className="inv-commentary-header" onClick={() => toggleExpand(c.section)}>
            <h3>{c.title}</h3>
            <span className="inv-toggle">{expanded[c.section] ? '▼' : '▶'}</span>
          </div>
          <div className="inv-commentary-body">
            <p className="inv-commentary-text">{c.commentary}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
